const psvTypes = [
  {"value": "", "label": ""},
  {"value":"COI", "label":"COI"},
  {"value":"NPDB", "label":"NPDB"},
  {"value":"NPI", "label":"NPI"},
  {"value":"OIG_SAM", "label":"OIG / SAM"},
  {"value":"PEER_REFERENCES", "label":"Peer References"},
  {"value":"PROVIDER_BOARD_CERTIFICATION", "label":"Provider Board Cert."},
  {"value":"PROVIDER_DEA", "label":"Provider DEA"},
  {"value":"PROVIDER_LICENSE", "label":"Provider License"},
  {"value":"OTHER", "label":"Other"},
];

export default psvTypes;